export default "__VITE_ASSET__DNWcutul__"